import { render, staticRenderFns } from "./DataSharingDialog.vue?vue&type=template&id=b9bd751c"
import script from "./DataSharingDialog.vue?vue&type=script&lang=js"
export * from "./DataSharingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports